<template>
  <div class="head_wrap" :class="bgOpacity ? 'bgopacity' : ''">
    <div class="head">
      <div class="head_con">
        <router-link to="/">
          <h1 class="logo"></h1>
        </router-link>
        <ul class="menu_list">
          <router-link to="/" exact>
            <li class>
              <a href="javascript:;">
                <i class="c_line"></i>
                {{ $t("m.header.home") }}
              </a>
            </li>
          </router-link>
          <router-link to="/produce">
            <li>
              <a href="javascript:;">
                <i class="s_line"></i>
                <i class="c_line"></i>
                {{ $t("m.header.company") }}
              </a>
            </li>
          </router-link>
          <router-link to="/aboutUs">
            <li>
              <a href="javascript:;">
                <i class="s_line"></i>
                <i class="c_line"></i>
                {{ $t("m.header.corporate") }}
              </a>
            </li>
          </router-link>
          <router-link to="/recruitment">
            <li>
              <a href="javascript:;">
                <i class="s_line"></i>
                <i class="c_line"></i>
                {{ $t("m.header.products") }}
              </a>
            </li>
          </router-link>
          <router-link to="/contactUs">
            <li>
              <a href="javascript:;">
                <i class="s_line"></i>
                <i class="c_line"></i>
                {{ $t("m.header.joinus") }}
              </a>
            </li>
          </router-link>

          <a class="language_else">
            <li>
              <a @click="toggleLang">{{defaultLang}}</a>
              <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">
                <ul class="langUl" v-if="isLang">
                  <li v-for="item in langList" :key="item.id" @click="changeItem(item)">{{item.id}}</li>
                </ul>
              </transition>
            </li>
          </a>

          <!-- <li class="language_1">
            <a href="javascript:;" class="simple" :class="langs == 'zh'? 'simple current': ''" @click="changeLang('zh')">简体</a>
            <a href="javascript:;" :class="langs == 'kr'? 'current': ''" @click="changeLang('kr')">
              <i class="s_line"></i>한국어
            </a>
            <a href="javascript:;" :class="langs == 'en'? 'current': ''" @click="changeLang('en')">
              <i class="s_line"></i>ENG
            </a>
          </li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { setCookie } from '../assets/js/cookie'
import { getCookie } from '../assets/js/cookie'
export default {
  data() {
    return {
      langs: 'zh',
      bgOpacity: true,
      isLang: false,
      defaultLang: 'CH',
      langList: [
        {
          id: 'CH',
          url: 'https://www.iclockwork.com/#/',
        },
        {
          id: 'EN',
          url: 'https://www.iclockwork.sg',
        },
        {
          id: 'KO',
          url: 'https://www.iclockwork.co.kr',
        },
      ],
    }
  },
  mounted: function () {
    if (getCookie('lang')) {
      this.langs = getCookie('lang')
    }
  },
  methods: {
    reload: function () {
      this.$router.go(0)
    },
    changeLang: function (e) {
      this.langs = e
      setCookie('lang', e, 1000000000)
      this.$i18n.locale = this.langs
    },
    changeItem(i) {
      this.defaultLang = i.id
      this.isLang = false
      window.open(i.url)
    },
    toggleLang() {
      this.isLang = !this.isLang
    },
  },
  watch: {
    //   '$route.path':function(newPath,oldPath){
    //       if(newPath=='/'){
    //           this.bgOpacity = false
    //       }else{
    //           this.bgOpacity = true
    //       }
    //   }
  },
}
</script>
<style lang="scss">
.head_wrap {
  width: 100%;
  position: absolute;
  top: 0rem;
  left: 0;
  z-index: 999;
  height: 1.08rem;
  border-bottom: 1px solid rgba(134, 134, 137, 0.44);
}
.bgopacity {
  background: rgba(11, 17, 23, 0.4);
}
.head_con {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  top: 0.25rem;
}
.head_con .logo {
  display: block;
  height: 0.56rem;
  width: 2.4rem;
  background: url(../assets/pcImg/icon.png) no-repeat;
  background-size: 100% 100%;
  text-indent: -9999px;
  overflow: hidden;
  position: absolute;
  left: 0.93rem;
  top: 50%;
  margin-top: -0.04rem;
  font-size: 1em;
}

.language_else {
  position: relative;
  float: right;
  width: 75px;
  height: 100%;
  line-height: 42px;
  font-size: 16px;
  color: #fff;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  &::before {
    content: '';
    width: 20px;
    height: 20px;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -15px;
    background: url(../assets/pcImg/lan.png) no-repeat;
    background-size: 100% 100%;
  }
  &::after {
    content: '';
    width: 12px;
    height: 7px;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -9.5px;
    background: url(../assets/pcImg/arrow.png) no-repeat;
    background-size: 100% 100%;
  }
  .langUl {
    position: absolute;
    top: 50%;
    margin-top: 64%;
    width: 74px;
    height: 120px;
    background: rgba(26, 30, 39, 0.7);
    li {
      width: 100% !important;
      height: 40px;
      color: #ffffff;
      font-size: 16px;
      border-bottom: 1px solid #75798c;
      transition: all 0.6s;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background: rgba(26, 30, 39, 0.75);
      }
    }
  }
}
.menu_list {
  display: block;
  width: auto;
  list-style: none;
  height: 70px;
  position: absolute;
  right: 1rem;
  top: 0;
  margin: 0;
}
.menu_list li {
  width: auto;
  display: block;
  float: left;
}
.menu_list li a {
  width: auto;
  display: block;
  float: left;
  height: 0.6rem;
  padding: 0 30px;
  line-height: 0.6rem;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  position: relative;
  text-align: center;
  -webkit-transition: font-weight 0.3s;
  transition: font-weight 0.3s;
}
.menu_list a.active a .c_line,
.menu_list li:hover a .c_line {
  display: block;
}
.menu_list li a .c_line {
  display: none;
  height: 3px;
  width: 80px;
  background: #f08200;
  overflow: hidden;
  position: absolute;
  left: 50%;
  margin-left: -40px;
  bottom: 3px;
  border-radius: 1.5px;
  -webkit-transition: bottom 0.2s;
  transition: bottom 0.2s;
}
.menu_list li a .s_line {
  display: block;
  height: 13px;
  width: 1px;
  background: #fff;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -6.5px;
  opacity: 0.3;
  filter: alpha(opacity=30);
}
.menu_list .language_1 a.current {
  opacity: 1;
  filter: alpha(opacity=100);
  color: #f08200;
}
.menu_list .language_1 a:hover {
  font-weight: 400;
  opacity: 1;
  filter: alpha(opacity=100);
}
.menu_list .language_1 .simple {
  margin-left: 20px;
}
.menu_list .language_1 a {
  height: 20px;
  width: auto;
  font-size: 14px;
  line-height: 20px;
  margin-top: 40px;
  padding: 0 8px;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
</style>